/**
 * Per-tab/session active workspace storage.
 *
 * Stored in sessionStorage so each browser tab can pin a different
 * workspace without affecting other tabs of the same Clerk user.
 * The value is sent on every API call as `X-Workspace-Id` and the
 * server validates it against the caller's accessible workspaces.
 *
 * Falls back to the per-user DB pointer (set by POST /workspaces/:id/activate)
 * when no value is present in this tab's sessionStorage.
 */

const KEY = "lt_active_workspace_id";

export function getActiveWorkspaceId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setActiveWorkspaceId(id: number | string | null): void {
  if (typeof window === "undefined") return;
  try {
    if (id == null) window.sessionStorage.removeItem(KEY);
    else window.sessionStorage.setItem(KEY, String(id));
  } catch {
    /* sessionStorage unavailable — silently degrade to DB pointer fallback */
  }
}
